import script from "./AgregarBodegaDialogComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AgregarBodegaDialogComponent.vue?vue&type=script&setup=true&lang=js"

import "./AgregarBodegaDialogComponent.vue?vue&type=style&index=0&id=233b058d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233b058d"]])

export default __exports__